import React from 'react'
import { Tooltip } from '@mantine/core'
import { AppIconButton } from '../../app/common/ui'
import { FiInfo } from 'react-icons/fi'

export interface FieldHelpIconProps {
  label: string
  onClick: () => void
}

/** Inline (i) control beside a form label — opens field help without submitting the form. */
export default function FieldHelpIcon ({ label, onClick }: FieldHelpIconProps) {
  return (
    <Tooltip label={`Help: ${label}`} withArrow position="top">
      <AppIconButton
        type="button"
        variant="subtle"
        size="sm"
        aria-label={`Field definition: ${label}`}
        title={`Help: ${label}`}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          onClick()
        }}
        sx={{
          color: 'var(--gs-muted)',
          '&:hover': { color: 'var(--gs-accent, #e85d04)' }
        }}
      >
        <FiInfo size={14} aria-hidden />
      </AppIconButton>
    </Tooltip>
  )
}
